export const toastConfig = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  draggable: true,
  pauseOnHover: true,
};

export const notifyOfflineToastConfig = {
  autoClose: false,
  closeOnClick: false,
  closeButton: false,
};
